import type { Components } from '@mildang/mui';

const createSvgIcon = (): Components => ({
  MuiSvgIcon: {
    variants: [
      { props: { fontSize: 'xLarge' }, style: { fontSize: 32 } },
      { props: { fontSize: 'large' }, style: { fontSize: 28 } },
      { props: { fontSize: 'medium' }, style: { fontSize: 24 } },
      { props: { fontSize: 'small' }, style: { fontSize: 22 } },
      { props: { fontSize: 'xSmall' }, style: { fontSize: 18 } },
    ],
  },
});

export default createSvgIcon;
